import { Dispatch, SetStateAction } from 'react';
import ModalComponent from '../../../../components/ModalComponent';
import CarrouselImagesComponent from '../../../../components/CarrouselImagesComponent/CarrouselImagesComponent';
import { Box } from '@mui/material';

interface IDefenseEventImagesModalProps {
  isOpen: boolean;
  selectedImages: string[];
  setSelectedImages: Dispatch<SetStateAction<any>>;
  onClose?: () => void;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

const DefenseEventImagesModal = ({
  isOpen,
  setSelectedImages,
  selectedImages,
  setIsOpen,
}: IDefenseEventImagesModalProps) => {
  const handleClose = () => {
    setSelectedImages([]);
    setIsOpen(false);
  };

  return (
    <ModalComponent
      title={'Imagens do Evento'}
      onClose={handleClose}
      isOpen={isOpen}
    >
      <Box
        sx={{
          width: 'auto',
          height: 'auto',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CarrouselImagesComponent items={selectedImages} />
      </Box>
    </ModalComponent>
  );
};

export default DefenseEventImagesModal;
